import { render, staticRenderFns } from "./RecentObservations.vue?vue&type=template&id=7a65895d&scoped=true&"
import script from "./RecentObservations.vue?vue&type=script&lang=js&"
export * from "./RecentObservations.vue?vue&type=script&lang=js&"
import style0 from "./RecentObservations.vue?vue&type=style&index=0&id=7a65895d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a65895d",
  null
  
)

export default component.exports